import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from 'src/app/services/admin/admin.service';
import { MessagesService } from 'src/app/services/message/messages.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { EventsService } from 'src/app/services/events/events.service';

@Component({
  selector: 'app-voucher-delete',
  templateUrl: './voucher-delete.component.html',
  styleUrls: ['./voucher-delete.component.less']
})
export class VoucherDeleteComponent implements OnInit {
  @Input() voucherDetails;
  public showSingleDel = true;

  constructor(private ngbActiveMod: NgbActiveModal, private admin: AdminService, private msg: MessagesService, private load: NgxSpinnerService,
    private events: EventsService) {
  }

  ngOnInit() {
    this.initTemplate();
  }

  // inits the view of delete voucher
  private initTemplate() {
    if (this.voucherDetails.data.hasOwnProperty('id') === true) {
      this.showSingleDel = true;
    }

    if (typeof this.voucherDetails.data === 'object' && this.voucherDetails.data.length >= 1) {
      this.showSingleDel = false;
    }
  }

  // closes the modal
  public closeModal() {
    this.ngbActiveMod.close({ task: 'close modal', success: true });
  }

  // delete voucher
  public async deleteVoucher() {
    this.load.show();

    const id = this.voucherDetails.data.id;
    const from = this.voucherDetails.from;

    if (this.voucherDetails.data.hasOwnProperty('id') === true) {
      this.admin.deleteVoucher(id)
        .then(res => this.success(res, id, from))
        .catch(err => this.error(err));
    }

    if (typeof this.voucherDetails.data === 'object' && this.voucherDetails.data.length >= 1) {
      const length = this.voucherDetails.data.length;
      const array = this.voucherDetails.data;
      let l = 0;

      while (l < length) {
        let res;

        try {
          res = await this.admin.deleteVoucher(array[l]);
          this.msg.success(res);
          this.events.triggerTableReload(array[l], from, 'delete-array', {});
        } catch (e) {
          console.log(e);
          this.msg.error(e);
          this.load.hide();
        }
        l++;
      }
      this.ngbActiveMod.close({ user: 'ok', task: 'delete', success: true });
      this.load.hide();
    }
  }

  // handle success
  private success(msg, userid, from) {
    this.msg.success(msg);
    this.events.triggerTableReload(userid, from, 'delete', {});
    this.ngbActiveMod.close({ user: userid, task: 'delete', success: true });
  }

  // handle error
  private error(msg) {
    this.load.show();
    this.msg.error(msg);
  }

}
